<div class="container mt-5">

    <foehn-page-counter></foehn-page-counter>


    <foehn-form>
        <div class="row">

            <div class="col-md-8">
                <foehn-boolean-radio
                    #foehnBooleanRadioIsResidentVaud
                    [(model)]="form.requestOrigin.isResidentVaud"
                    [label]="'request-origin.isResidentVaud.label' | fromDictionary"
                    [required]="true"
                    name="requestOrigin.isResidentVaud"
                >
                </foehn-boolean-radio>
            </div>

            <div *ngIf="!isResidentCanton && isResidentCanton !== null" [innerHTML]="getMessageNonResident()"
                 class="col-md-8"
                 style="margin-bottom: 30px;">
            </div>

            <div class="col-md-8">
                <foehn-select
                    [(model)]="form.requestOrigin.libelleConfigurable"
                    [elementValue]="wholeValue"
                    [elements]="situations"
                    [hidden]="!isResidentCanton"
                    [label]="'request-origin.situation.label' | fromDictionary"
                    [required]="true"
                    elementLabel="valeur"
                    name="requestOrigin.situations"
                >
                </foehn-select>

            </div>

            <div *ngIf="form.requestOrigin.libelleConfigurable" [hidden]="!isResidentCanton"
                 [innerHTML]="getRenderHTML()"
                 class="col-md-8"
                 style="margin-bottom: 30px;">
            </div>

            <div class="col-md-8">
                <foehn-boolean-radio
                    #foehnBooleanRadioIsSelfRequest
                    [(model)]="form.requestOrigin.isSelfRequest"
                    [hidden]="!isResidentCanton"
                    [label]="'request-origin.isSelfRequest.label' | fromDictionary"
                    [required]="true"
                    name="requestOrigin.isSelfRequest"
                >
                </foehn-boolean-radio>
            </div>

            <div class="col-md-8">

                <foehn-select
                    [(model)]="form.requestOrigin.initiator"
                    [disabled]="isBenefitRecipient"
                    [elementValue]="wholeValue"
                    [elements]="initiators"
                    [hidden]="!isResidentCanton"
                    [label]="'request-origin.initiator.label' | fromDictionary"
                    [required]="true"
                    elementLabel="valeur"
                    name="requestOrigin.initiator"
                >
                </foehn-select>

                <foehn-input-text
                    [(model)]="form.requestOrigin.lastName"
                    [hidden]="!isResidentCanton"
                    [label]="'request-origin.lastName.label' | fromDictionary"
                    [required]="true"
                    name="requestOrigin.lastName"
                >
                </foehn-input-text>

                <foehn-input-text
                    [(model)]="form.requestOrigin.firstName"
                    [hidden]="!isResidentCanton"
                    [label]="'request-origin.firstName.label' | fromDictionary"
                    [required]="true"
                    name="requestOrigin.firstName"
                >
                </foehn-input-text>

                <foehn-input-email
                    [(model)]="form.requestOrigin.email"
                    [hidden]="!isResidentCanton"
                    [label]="'request-origin.email.label' | fromDictionary"
                    [required]="true"
                    name="requestOrigin.email"
                    pattern="/^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$/"
                >
                </foehn-input-email>

                <foehn-input-phone
                    [(model)]="form.requestOrigin.phone"
                    [hidden]="!isResidentCanton"
                    [label]="'request-origin.phone.label' | fromDictionary"
                    [required]="true"
                    name="requestOrigin.phone"
                >
                </foehn-input-phone>

            </div>
            <div class="col-md-8">
                <captcha></captcha>

                <foehn-navigation
                    (onNext)="send()"
                    (onPrevious)="previous()"
                    [showNextButton]="isResidentCanton"
                    id="navigation"
                ></foehn-navigation>
            </div>
        </div>
    </foehn-form>
</div>
